import React, {Component} from 'react';
import style from '../css/chipsModal.css';
import {openCloseModal} from '../../../../actions/modalActions';
import {CHIPS, getHumanReadableChipValue} from '../../../../constants/chips';
import {getFormattedCurrency} from '../../../../helpers/localization';
import {CHIPS_LIST_MODAL_TYPE} from '../../../../constants/identifiers'
import {ASSETS_URL} from '../../../../constants/endpoints';
import {selectChip} from '../../../../actions/raceCardActions';

class ChipsModal extends Component {

    componentDidMount() {
        document.body.style.overflow = 'hidden';
    }

    componentWillUnmount() {
        document.body.style.overflow = 'auto';
    }

    render() {
        let chipsListUI = CHIPS.map(
            (chip, index) => <div
                id={'chip_' + index}
                key={'chip_' + index}
                className={style.chipIconContainer}
                onClick={(event) => this._chipClickHandler(event, index)}>
                <div className={style.chipValueOuter}>
                    <div
                        className={style.chipValueInner}>{getFormattedCurrency(this.props.store, getHumanReadableChipValue(index).toString(), 0)}</div>
                </div>
                <img className={style.chipIcon} src={`${ASSETS_URL + CHIPS[index].assetChip}`} alt={'chips'}/>
            </div>
        );

        return (
            <div
                className={style.chipsPopupModalContainer}
                onClick={() => this.props.store.dispatch(openCloseModal(CHIPS_LIST_MODAL_TYPE))}>
                <div className={style.chipsPopupModal}>{chipsListUI.reverse()}</div>
            </div>
        );
    }

    _chipClickHandler(clickEvent, index) {
        clickEvent.stopPropagation();
        this.props.store.dispatch(selectChip(index));
    }
}

export default ChipsModal;



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/mobile/components/chipsModal.js